//
// locales/vanilla/ja.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/ja.json';
import localeData from 'react-intl/locale-data/ja.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
